import { Injectable } from '@angular/core';
import { LoginPoem } from '../dto/login-poem';

@Injectable({
  providedIn: 'root'
})
export class LoginPoemService {
  private poemCollection: LoginPoem[];

  constructor() {
    this.poemCollection = [
      {
        id: 0,
        title: '《早春呈水部张十八员外》 唐·韩愈',
        firstLine: '天街小雨润如酥，草色遥看近却无。',
        secondLine: '最是一年春好处，绝胜烟柳满皇都。',
        image: 'spring_ChunFen.jpg'
      },
      {
        id: 1,
        title: '《小荷》 宋·杨万里',
        firstLine: '泉眼无声惜细流，树阴照水爱晴柔。',
        secondLine: '小荷才露尖尖角，早有蜻蜓立上头。',
        image: 'summer_XiaZhi.jpg'
      },
      {
        id: 2,
        title: '《秋词二首·其一》 唐·刘禹锡',
        firstLine: '自古逢秋悲寂寥，我言秋日胜春朝。',
        secondLine: '晴空一鹤排云上，便引诗情到碧霄。',
        image: 'autumn_LiQiu.jpg'
      },
      {
        id: 3,
        title: '《别董大》 唐·高适',
        firstLine: '千里黄云白日曛，北风吹雁雪纷纷。',
        secondLine: '莫愁前路无知己，天下谁人不识君。',
        image: 'winter_DaHan.jpg'
      },
    ]; 
  }

  getRandomPoem(): LoginPoem {
    let max = this.poemCollection.length - 1;
    let min = 0;
    let index = Math.floor(Math.random() * (max - min + 1)) + min;
    return this.poemCollection[index];
  }

  getNextPoem(poem: LoginPoem) : LoginPoem {
    let newId = poem.id + 1;
    if (newId > this.poemCollection.length - 1 ) {
      newId = 0;
    } 
    return this.poemCollection[newId];
  }
}
